import React from 'react'
import { VertContainer } from '@vertem-core/vertice-ds';
import SkeletonInput from 'antd/es/skeleton/Input';
import SkeletonButton from 'antd/es/skeleton/Button';
import MediaQuery from 'react-responsive';

const HeaderPlaceholder = () => {
  return (
    <>
      <MediaQuery minWidth={1024}>
        <VertContainer fluid className="header-desktop-container" style={{width: '100vw', boxSizing: 'border-box', maxWidth: '100%'}}>
          <VertContainer className="vert-box-header" spacingX="regular">
            <div className="header-main-content">
              <div className="header-logo">
                <SkeletonInput
                  active
                  rootClassName="col padding-x-extra-small"
                  style={{
                    height: '49px',
                    maxWidth: '100%',
                    width: '112px',
                    display: 'block',
                  }}
                />
              </div>
              <div className="header-search">
                <SkeletonInput
                  active
                  rootClassName="col padding-x-extra-small"
                  style={{
                    height: '49px',
                    maxWidth: '100%',
                    width: '400px',
                    display: 'block',
                  }}
                />
              </div>
              <div style={{ flex: 1 }} />
              <div className="header-points">
                <SkeletonButton
                  active
                  shape="round"
                  rootClassName="col padding-x-extra-small"
                  style={{
                    height: '49px',
                    maxWidth: '100%',
                    width: '205px',
                    display: 'block',
                  }}
                />
              </div>
              <div>
                <SkeletonInput
                  active
                  rootClassName="col padding-x-extra-small"
                  style={{
                    height: '14px',
                    maxWidth: '100%',
                    width: '102px',
                    display: 'block',
                  }}
                />
              </div>
              <div>
                <SkeletonInput
                  active
                  rootClassName="col padding-x-extra-small"
                  style={{
                    height: '14px',
                    maxWidth: '100%',
                    width: '102px',
                    display: 'block',
                  }}
                />
              </div>
            </div>
          </VertContainer>
        </VertContainer>
      </MediaQuery>
      <MediaQuery maxWidth={1023}>
        <VertContainer fluid className="header-mobile-container" style={{width: '100vw', zIndex: 9999, position: 'relative', boxSizing: 'border-box', maxWidth: '100%', padding: '30px 0', boxShadow: "0 2px 8px 0 rgba(0, 0, 20, 0.12)"}}>
          <VertContainer className="vert-box-header" spacingX="regular">
            <div className="header-mobile-menu-content">
                <SkeletonButton
                  active
                  rootClassName="col padding-x-extra-small"
                  style={{
                    height: '40px',
                    maxWidth: '100%',
                    width: '45px',
                    display: 'block',
                    minWidth: 'auto',
                    minHeight: 'auto'
                  }}
                />
                <SkeletonButton
                  active
                  rootClassName="col padding-x-extra-small"
                  style={{
                    height: '40px',
                    maxWidth: '100%',
                    width: '100px',
                    display: 'block',
                    minWidth: 'auto',
                    minHeight: 'auto'
                  }}
                />

                <SkeletonButton
                  active
                  rootClassName="col padding-x-extra-small"
                  shape='round'
                  style={{
                    height: '30px',
                    maxWidth: '100%',
                    width: '30px',
                    display: 'block',
                    minWidth: 'auto',
                    minHeight: 'auto'
                  }}
                />
                <SkeletonButton
                  active
                  rootClassName="col padding-x-extra-small"
                  shape='round'
                  style={{
                    height: '30px',
                    maxWidth: '100%',
                    width: '30px',
                    display: 'block',
                    minWidth: 'auto',
                    minHeight: 'auto'
                  }}
                />
                <SkeletonButton
                  active
                  rootClassName="col padding-x-extra-small"
                  shape='round'
                  style={{
                    height: '30px',
                    maxWidth: '100%',
                    width: '30px',
                    display: 'block',
                    minWidth: 'auto',
                    minHeight: 'auto'
                  }}
                />
            </div>
          </VertContainer>
        </VertContainer>
      </MediaQuery>
    </>
  )
}

export default HeaderPlaceholder;
